"use client";
import Link from "next/link";
import { Box, Stack, Typography } from "@mui/material";
import { Masonry } from "@mui/lab";

import { useStore, observer } from "../../../../service/mobx";
import { entities } from "../../../../component/Search/Hooks";
import Preview from "./Preview";

function FourUp({ searchParams }) {
  const { search } = useStore();

  return (
    <>
      <ClearSearch searchParams={searchParams} />
      <Typography
        paragraph
        pb={2}
        pt={4}
        typography={{
          compact: "headlineSm",
          medium: "headlineMd",
          expanded: "headlineLg"
        }}
      >
        {searchParams.stars
          ? "My stuff"
          : search.userInput === ""
          ? "What's trending today"
          : "Top results"}
      </Typography>
      <Masonry
        sx={{ m: 0 }}
        columns={{
          compact: 1,
          medium: 2,
          expanded: 1,
          large: 2,
          extraLarge: 3
        }}
      >
        {entities.map(({ Icon, label, entityName, capital }) =>
          search[`suggested${capital}`]?.length ? (
            <Box key={entityName} pb={5}>
              <Preview
                Icon={Icon}
                label={label}
                capital={capital}
                entityName={entityName}
              />
            </Box>
          ) : null
        )}
      </Masonry>
    </>
  );
}

export default observer(FourUp);

function ClearSearch({ searchParams }) {
  const { q, ...filters } = searchParams;
  const hasFilters = Object.keys(filters).length !== 0;

  return q || hasFilters ? (
    <Stack
      spacing={0.5}
      alignItems="center"
      direction="row"
      typography="labelSm"
      color="surface.on.color"
    >
      <Box
        maxWidth="30ch"
        textOverflow="ellipsis"
        sx={theme => ({
          ...theme.typography.lineClamp(1),
          whiteSpace: "break-spaces"
        })}
      >
        {`Searching${hasFilters ? " with filters" : ""}${
          q ? ` for ${q}` : ""
        }.`}
      </Box>
      <Typography
        component={Link}
        href="/search"
        typography="labelSm"
        sx={{ textDecoration: "none" }}
      >
        Clear search
      </Typography>
    </Stack>
  ) : null;
}
